import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const LaneSheetMedalsStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  options: [],
  areOptionsLoaded: false
};

const LaneSheetMedalsContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <LaneSheetMedalsStateContext.Provider value={stateHook}>
      {children}
    </LaneSheetMedalsStateContext.Provider>
  );
};

export default LaneSheetMedalsContextProvider;